import React from 'react';
import { observer } from 'mobx-react';
import type OrderItem from '@this/domain/order_item2';

interface Props {
  orderItem: OrderItem;
}

export const OrderItemWaitingSelect = observer(({ orderItem }: Props) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span style={{ marginRight: '5px' }}>引き継ぎ:</span>
      <select
        onChange={e => {
          orderItem.waiting = e.target.value === 'true';
        }}
        value={orderItem.waiting?.toString() ?? 'false'}
        style={{ marginBottom: '0px' }}
      >
        <option value="true">◯</option>
        <option value="false">×</option>
      </select>
    </div>
  );
});
